var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearchReportItemBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 118,
    viewBox: "0 0 126 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1632_2845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -9,
    width: 126,
    height: 153
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 -9H0V143.002H126V-9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1632_2845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8689 44.9094H36.5284C41.2711 44.9094 45.1239 48.7871 45.1239 53.5606V72.1907C45.1239 76.9642 41.2711 80.8419 36.5284 80.8419H35.8689C31.1262 80.8419 27.2734 76.9642 27.2734 72.1907V53.55C27.2734 48.7766 31.1262 44.8988 35.8689 44.8988V44.9094Z",
    stroke: "#9B87BF",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5284 116.785H35.8689C31.1157 116.785 27.2734 112.907 27.2734 108.134V89.4931C27.2734 84.7091 31.1262 80.8419 35.8689 80.8419H36.5284C41.2816 80.8419 45.1239 84.7197 45.1239 89.4931V108.134C45.1239 112.907 41.2816 116.785 36.5284 116.785Z",
    fill: "#44BB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3097 80.8525H62.6501C57.897 80.8525 54.0547 76.9747 54.0547 72.2013V36.4584C54.0547 31.6849 57.9074 27.8072 62.6501 27.8072H63.3097C68.0628 27.8072 71.9051 31.6849 71.9051 36.4584V72.2013C71.9051 76.9747 68.0628 80.8525 63.3097 80.8525Z",
    fill: "#5061F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6501 80.8525H63.3097C68.0524 80.8525 71.9051 84.7303 71.9051 89.5037V125.247C71.9051 130.02 68.0524 133.898 63.3097 133.898H62.6501C57.9074 133.898 54.0547 130.02 54.0547 125.247V89.5037C54.0547 84.7303 57.9074 80.8525 62.6501 80.8525Z",
    stroke: "#9B87BF",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.872 80.8525H116.213C111.47 80.8525 107.617 76.9747 107.617 72.2013V-0.348788C107.617 -5.13277 111.47 -9 116.213 -9H116.872C121.615 -9 125.468 -5.13277 125.468 -0.348788V72.2013C125.468 76.9747 121.615 80.8525 116.872 80.8525Z",
    fill: "#5061F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.213 80.8525H116.872C121.615 80.8525 125.468 84.7303 125.468 89.5037V162.054C125.468 166.827 121.615 170.705 116.872 170.705H116.213C111.47 170.705 107.617 166.827 107.617 162.054V89.5037C107.617 84.7303 111.47 80.8525 116.213 80.8525Z",
    stroke: "#9B87BF",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4314 8.96628H90.0909C94.8336 8.96628 98.6864 12.844 98.6864 17.6175V72.1907C98.6864 76.9642 94.8336 80.8419 90.0909 80.8419H89.4314C84.6887 80.8419 80.8359 76.9642 80.8359 72.1907V17.6175C80.8359 12.844 84.6887 8.96628 89.4314 8.96628Z",
    stroke: "#9B87BF",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0909 152.728H89.4314C84.6782 152.728 80.8359 148.85 80.8359 144.077V89.5037C80.8359 84.7303 84.6887 80.8525 89.4314 80.8525H90.0909C94.8441 80.8525 98.6864 84.7303 98.6864 89.5037V144.077C98.6864 148.85 94.8336 152.728 90.0909 152.728Z",
    fill: "#5061F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3843 80.8525C18.3843 85.8156 14.385 89.8409 9.45389 89.8409C4.52277 89.8409 0.523438 85.8156 0.523438 80.8525C0.523438 75.8894 4.52277 71.8641 9.45389 71.8641C14.385 71.8641 18.3843 75.8894 18.3843 80.8525Z",
    fill: "#5061F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchReportItemBg);
export default __webpack_public_path__ + "static/media/research-report-item-bg.c11ce26b55645e1ecfb7cd63a452f5e1.svg";
export { ForwardRef as ReactComponent };